import { FC } from 'react';
import { useField } from 'formik';

import ButtonDefault from 'shared/components/Buttons/ButtonsDefault';

import { OPPORTUNITY_LOCATION_TYPE } from '@joc/api-gateway';

import styles from './LocationType.module.scss';

const LocationType: FC<{ name: string }> = ({ name }) => {
	const [field, , helpers] = useField<Array<OPPORTUNITY_LOCATION_TYPE>>(name);

	const toggleLocationType = (createdBy: OPPORTUNITY_LOCATION_TYPE) => {
		const newCreatedBy = field.value.includes(createdBy)
			? field.value.filter(item => item !== createdBy)
			: [...field.value, createdBy];

		helpers.setValue(newCreatedBy).finally();
	};

	return (
		<section className={styles.locationType}>
			<span className={styles.locationType_label}>Location type:</span>
			<div className={styles.locationType__list}>
				<ButtonDefault
					classList={[
						'secondary',
						field.value.includes(OPPORTUNITY_LOCATION_TYPE.LOCAL) ? 'secondary_active' : '',
					]}
					parentClassName={styles.locationType__list_item}
					title="Local"
					clickHandler={() => toggleLocationType(OPPORTUNITY_LOCATION_TYPE.LOCAL)}
				/>
				<ButtonDefault
					classList={[
						'secondary',
						field.value.includes(OPPORTUNITY_LOCATION_TYPE.VIRTUAL) ? 'secondary_active' : '',
					]}
					parentClassName={styles.locationType__list_item}
					title="Virtual"
					clickHandler={() => toggleLocationType(OPPORTUNITY_LOCATION_TYPE.VIRTUAL)}
				/>
			</div>
		</section>
	);
};

export default LocationType;
